import React, {useEffect, useState} from 'react';
import {Image} from 'react-bootstrap';
import {LayoutData} from '@Panels/user-schedule-panel/user-schedule-panel.types';
import styles from './menu-layout.module.scss';

const SELECTED_IMAGE_PREFIX = 'selected-';

interface MenuLayoutProps {
  className?: string;
  itemClassName?: string;
  layout: string;
  big?: boolean;
  layoutPath: string;
  showSmallImages?: boolean;
  styleImages: Array<string>;

  onLayoutSelected(layout: string): void;
}

export function MenuLayout({className = '', itemClassName = '', ...props}: MenuLayoutProps) {
  const [selectedLayout, setSelectedLayout] = useState<string>(props.layout);

  const onLayoutSelected = (layout: string) => {
    setSelectedLayout(layout);
    props.onLayoutSelected(layout);
  };

  const getFileNamePrefix = (layout: string) => {
    return layout === selectedLayout && (layout === LayoutData.SLANTED_SPORTS_LAYOUT || layout === LayoutData.STRAIGHT_SPORTS_LAYOUT) ? SELECTED_IMAGE_PREFIX : '';
  };

  useEffect(() => {
    setSelectedLayout(props.layout);
  }, [props.layout]);

  const getAllStyles = () => {
    return props.styleImages.map((layout) => {
      return (
        <li
          className={`${styles.menuLayout} ${layout === selectedLayout ? styles.menuLayoutSelected : ''} ${itemClassName}`}
          key={layout}
          onClick={() => {
            return onLayoutSelected(layout);
          }}
        >
          <Image
            className={`${styles.menuLayoutImage} ${props.showSmallImages ? styles.smallLayoutImage : styles.bigLayoutImage}`}
            src={`${props.layoutPath + getFileNamePrefix(layout) + layout}.png`}
            alt={window.i18next.t('pmwjs_image')}
          />
        </li>
      );
    });
  };

  return <ul className={`${className} ${styles.menuLayouts} ${props.big ? '' : styles.smallScreenSection}`}>{getAllStyles()}</ul>;
}
